import { useSuspenseQuery } from "@tanstack/react-query";
import { METRIC_STALE_TIME } from "../constants";
import { DEFAULT_CAMPAIGN } from "../constants/campaignPerformance";
import type { CampaignImpactResponse } from "../types";
import { formatLocalDate } from "../utils/date";
import { fetchCampaignImpact, type CampaignImpactQueryParams } from "./useCampaignImpactQuery";

const AIRLINES_CAMPAIGN_IMPACT_ENDPOINT = "/api/v1/campaigns/impact/airlines";

export type AirlinesCampaignImpactQueryParams = CampaignImpactQueryParams & {
  airlineCode: string;
};

const todayKey = (): string => formatLocalDate(new Date());

export const useAirlinesCampaignImpactQuery = ({
  period,
  airlineCode,
}: AirlinesCampaignImpactQueryParams) => {
  const endpoint = `${AIRLINES_CAMPAIGN_IMPACT_ENDPOINT}/${airlineCode}`;

  return useSuspenseQuery({
    queryKey: [endpoint, period, DEFAULT_CAMPAIGN, todayKey()],
    queryFn: () => fetchCampaignImpact(endpoint, { period, campaign: DEFAULT_CAMPAIGN }),
    select: (data: CampaignImpactResponse) => data,
    staleTime: METRIC_STALE_TIME,
  });
};
